import { useMutation, useQueryClient } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import { addSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import OpeningTime from "../../OpeningTimes/OpeningTime";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";
import { OpeningTimeMapper } from "../../OpeningTimes/OpeningTimeMapper";

export const useAddOdcOpeningTime = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (openingTime: OpeningTime) =>
      axios.post<number>(
        openingTimesUrls.openingTimesForODCsWithId(openingTime.ParentId),
        OpeningTimeMapper.toWriteDto(openingTime, 0)
      ),
    onSuccess: async (response: AxiosResponse<number>, variables: OpeningTime) => {
      await queryClient.invalidateQueries(openingTimeWithIdQueryKey(variables.ParentId, "odcs"));
      toast.success(addSuccessMessage(response.data, "OpeningTime"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
